/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopePokeballConfigCreatedResponse,
  ApiEnvelopePokeballConfigListResponse,
  ApiEnvelopePokeballEmptyResponse,
  ApiEnvelopePokeballRunResponse,
  PokeballConfigInputDto,
  PokeballStopPokeballParams,
  RunPokeballRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type pokeballGetPokeballConfigsResponse200 = {
  data: ApiEnvelopePokeballConfigListResponse
  status: 200
}

export type pokeballGetPokeballConfigsResponseSuccess = (pokeballGetPokeballConfigsResponse200) & {
  headers: Headers;
};
;

export type pokeballGetPokeballConfigsResponse = (pokeballGetPokeballConfigsResponseSuccess)

export const getPokeballGetPokeballConfigsUrl = () => {




  return `/api/Pokeball`
}

export const usePokeballGetPokeballConfigsHook = (): ( options?: RequestInit) => Promise<pokeballGetPokeballConfigsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getPokeballGetPokeballConfigsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type pokeballCreatePokeballConfigResponse200 = {
  data: ApiEnvelopePokeballConfigCreatedResponse
  status: 200
}

export type pokeballCreatePokeballConfigResponse400 = {
  data: ApiEnvelopePokeballConfigCreatedResponse
  status: 400
}

export type pokeballCreatePokeballConfigResponseSuccess = (pokeballCreatePokeballConfigResponse200) & {
  headers: Headers;
};
export type pokeballCreatePokeballConfigResponseError = (pokeballCreatePokeballConfigResponse400) & {
  headers: Headers;
};

export type pokeballCreatePokeballConfigResponse = (pokeballCreatePokeballConfigResponseSuccess | pokeballCreatePokeballConfigResponseError)

export const getPokeballCreatePokeballConfigUrl = () => {




  return `/api/Pokeball`
}

export const usePokeballCreatePokeballConfigHook = (): (pokeballConfigInputDto?: PokeballConfigInputDto, options?: RequestInit) => Promise<pokeballCreatePokeballConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (pokeballConfigInputDto?: PokeballConfigInputDto, options?: RequestInit) => {

        return customFetcher(getPokeballCreatePokeballConfigUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(pokeballConfigInputDto)
  }
);
      }
  }


export type pokeballUpdatePokeballConfigResponse200 = {
  data: ApiEnvelopePokeballEmptyResponse
  status: 200
}

export type pokeballUpdatePokeballConfigResponse400 = {
  data: ApiEnvelopePokeballEmptyResponse
  status: 400
}

export type pokeballUpdatePokeballConfigResponse404 = {
  data: ApiEnvelopePokeballEmptyResponse
  status: 404
}

export type pokeballUpdatePokeballConfigResponseSuccess = (pokeballUpdatePokeballConfigResponse200) & {
  headers: Headers;
};
export type pokeballUpdatePokeballConfigResponseError = (pokeballUpdatePokeballConfigResponse400 | pokeballUpdatePokeballConfigResponse404) & {
  headers: Headers;
};

export type pokeballUpdatePokeballConfigResponse = (pokeballUpdatePokeballConfigResponseSuccess | pokeballUpdatePokeballConfigResponseError)

export const getPokeballUpdatePokeballConfigUrl = (id: string,) => {




  return `/api/Pokeball/${id}`
}

export const usePokeballUpdatePokeballConfigHook = (): (id: string,
    pokeballConfigInputDto?: PokeballConfigInputDto, options?: RequestInit) => Promise<pokeballUpdatePokeballConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    pokeballConfigInputDto?: PokeballConfigInputDto, options?: RequestInit) => {

        return customFetcher(getPokeballUpdatePokeballConfigUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(pokeballConfigInputDto)
  }
);
      }
  }


export type pokeballDeletePokeballConfigResponse200 = {
  data: ApiEnvelopePokeballEmptyResponse
  status: 200
}

export type pokeballDeletePokeballConfigResponse404 = {
  data: ApiEnvelopePokeballEmptyResponse
  status: 404
}

export type pokeballDeletePokeballConfigResponseSuccess = (pokeballDeletePokeballConfigResponse200) & {
  headers: Headers;
};
export type pokeballDeletePokeballConfigResponseError = (pokeballDeletePokeballConfigResponse404) & {
  headers: Headers;
};

export type pokeballDeletePokeballConfigResponse = (pokeballDeletePokeballConfigResponseSuccess | pokeballDeletePokeballConfigResponseError)

export const getPokeballDeletePokeballConfigUrl = (id: string,) => {




  return `/api/Pokeball/${id}`
}

export const usePokeballDeletePokeballConfigHook = (): (id: string, options?: RequestInit) => Promise<pokeballDeletePokeballConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getPokeballDeletePokeballConfigUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type pokeballRunPokeballConfigResponse200 = {
  data: ApiEnvelopePokeballRunResponse
  status: 200
}

export type pokeballRunPokeballConfigResponse400 = {
  data: ApiEnvelopePokeballRunResponse
  status: 400
}

export type pokeballRunPokeballConfigResponse404 = {
  data: ApiEnvelopePokeballRunResponse
  status: 404
}

export type pokeballRunPokeballConfigResponseSuccess = (pokeballRunPokeballConfigResponse200) & {
  headers: Headers;
};
export type pokeballRunPokeballConfigResponseError = (pokeballRunPokeballConfigResponse400 | pokeballRunPokeballConfigResponse404) & {
  headers: Headers;
};

export type pokeballRunPokeballConfigResponse = (pokeballRunPokeballConfigResponseSuccess | pokeballRunPokeballConfigResponseError)

export const getPokeballRunPokeballConfigUrl = (id: string,) => {




  return `/api/Pokeball/${id}/run`
}

export const usePokeballRunPokeballConfigHook = (): (id: string,
    runPokeballRequest?: RunPokeballRequest, options?: RequestInit) => Promise<pokeballRunPokeballConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    runPokeballRequest?: RunPokeballRequest, options?: RequestInit) => {

        return customFetcher(getPokeballRunPokeballConfigUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(runPokeballRequest)
  }
);
      }
  }


export type pokeballStopPokeballResponse200 = {
  data: ApiEnvelopePokeballEmptyResponse
  status: 200
}

export type pokeballStopPokeballResponse404 = {
  data: ApiEnvelopePokeballEmptyResponse
  status: 404
}

export type pokeballStopPokeballResponseSuccess = (pokeballStopPokeballResponse200) & {
  headers: Headers;
};
export type pokeballStopPokeballResponseError = (pokeballStopPokeballResponse404) & {
  headers: Headers;
};

export type pokeballStopPokeballResponse = (pokeballStopPokeballResponseSuccess | pokeballStopPokeballResponseError)

export const getPokeballStopPokeballUrl = (id: string,
    params?: PokeballStopPokeballParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Pokeball/${id}/stop?${stringifiedParams}` : `/api/Pokeball/${id}/stop`
}

export const usePokeballStopPokeballHook = (): (id: string,
    params?: PokeballStopPokeballParams, options?: RequestInit) => Promise<pokeballStopPokeballResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    params?: PokeballStopPokeballParams, options?: RequestInit) => {

        return customFetcher(getPokeballStopPokeballUrl(id,params),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


